import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksCounterpartyDetails', {
    address: 'Address:',
    taxId: 'Tax ID:',
    email: 'Email:',
});
